import app from 'flarum/forum/app';

app.initializers.add('mattoid/flarum-ext-blacklist ', () => {
  console.log('[mattoid/flarum-ext-blacklist ] Hello, forum!');
});
